var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutListShapeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 10,
    height: 2,
    rx: 0.999999,
    transform: "rotate(-90 0 10)",
    fill: "#53BCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutListShapeIcon);
export default __webpack_public_path__ + "static/media/about-list-shape-icon.d93434e251a6acde1f3da9dd27f59b0e.svg";
export { ForwardRef as ReactComponent };